// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"kR-z","inlineTitle":"lR-z","sponsoredAdsWrapper":"mR-z","marketplaceRecosWrapper":"nR-z"};